import { authRoles } from 'app/auth/authRoles';
import Loadable from 'app/components/Loadable';
import { lazy } from 'react';

const ChargingRuleAnalytics = Loadable(lazy(() => import('./ChargingRuleAnalytics')));
const chargingRuleRoutes = [
  { path: '/charging-rules/default', element: <ChargingRuleAnalytics />, auth: authRoles.admin },
];
export default chargingRuleRoutes;
